// extracted by mini-css-extract-plugin
export default {"container":"AlbumList_container__pbCOX","box":"AlbumList_box__+MSCl"};